import { gql } from '@apollo/client';

export const REDEEM_MUTATION = gql`
  mutation Redeem($code: String!) {
    redeem(data: { code: $code }) {
      success
      message
      wearables
      packName
    }
  }
`;
